import { createFileRoute } from '@tanstack/react-router';

import {
  loadTenantPermissionResourceMessages,
  loadTenantPermissionResourceScreens,
  tenantPermissionResourceListScreen,
  tenantPermissionResourceListSearch,
} from '@/modules/tenant-permission-resource/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Permissões por Correspondente no caminho do legado (`router.tsx:2031-2040`): o menu passa a apontar para
// cá quando o manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/seguranca/recursos-correspondente/')({
  validateSearch: tenantPermissionResourceListSearch,
  staticData: { screen: tenantPermissionResourceListScreen },
  loader: () => loadTenantPermissionResourceMessages(),
  component: lazyScreen(loadTenantPermissionResourceScreens, 'TenantPermissionResourceListPage'),
});
